import { defineMessages } from "react-intl";

export const messages = defineMessages({
  point1: {
    id: "downloadMultipleEntities.modal.info.point1",
    defaultMessage: "Any columns currently selected",
    description: "Download entities modal - info - point 1",
  },
  point2: {
    id: "downloadMultipleEntities.modal.info.point2",
    defaultMessage: "Any filters currently applied",
    description: "Download entities modal - info - point 2",
  },
  point3: {
    id: "downloadMultipleEntities.modal.info.point3",
    defaultMessage: "Any sorting currently applied",
    description: "Download entities modal - info - point 3",
  },
  title: {
    id: "downloadEntities.modal.info.title",
    defaultMessage: "This download will include",
    description: "Download entities modal - info - title",
  },
});
